import { render, staticRenderFns } from "./UpdatesDisplay.vue?vue&type=template&id=c2340920&scoped=true"
import script from "./UpdatesDisplay.vue?vue&type=script&lang=js"
export * from "./UpdatesDisplay.vue?vue&type=script&lang=js"
import style0 from "./UpdatesDisplay.vue?vue&type=style&index=0&id=c2340920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2340920",
  null
  
)

export default component.exports